import { useQuery } from "@tanstack/react-query";
import { getPricingTextAPI, PricingPlanResponse } from "helpers/api";

/**
 * Hook to fetch and cache pricing feature lists.
 *
 *
 * @returns React Query result with pricing data (feature lists for each plan)
 */
export const usePricingData = () => {
  const query = useQuery<PricingPlanResponse>(
    ["pricing-text"],
    () => getPricingTextAPI(), // Wrap in arrow function to handle the optional parameter
    {
      staleTime: Infinity, // Never consider data stale during session
    }
  );

  return {
    ...query,
    pricingData: query.data,
    pricingDataLoading: query.isLoading,
  };
};
